import React from 'react'
import Popup from 'reactjs-popup'
import { Subscribe } from 'unstated'
import CalendarStore from '../Store/CalendarStore'
import date from 'date-and-time'

const WeekControls = ({ topBarMessage }) => (
  <Subscribe to={[CalendarStore]}>
    {({ state, changeWeek }) =>
      state.mode === 'becomeTeacher' ? null : (
        <div className='weekControls'>
          <p className='topBarMessage'>{topBarMessage}</p>
          <button
            className='navigate previous'
            onClick={() => changeWeek('previous')}
          />
          <Popup
            trigger={
              <button className='today' onClick={() => changeWeek()}>
                Today
              </button>
            }
            position='top center'
            on='hover'
          >
            <p className='popupDate'>
              {date.format(state.now, 'dddd, MMM DD')}
            </p>
          </Popup>
          <button
            className='navigate next'
            onClick={() => changeWeek('next')}
          />
        </div>
      )
    }
  </Subscribe>
)

export default WeekControls
